import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { DATA_NEW_PROFIT_SUPPLIERS, UID_NAME_TUPLES } from 'constants/dataSets';
import {
  PROFIT_CENTER_LINKS,
} from 'constants/formFields';
import { useUserMeQuery } from 'store/slices/user/apis/user';

import ProfitCenterItem from './components/ProfitCenterItem';

import type { TDate } from 'components/DatePicker/interfaces/TDate';
import type IProfitCenterLink from 'store/slices/dataSets/interfaces/IProfitCenterLink';
import type IProfitCenterLinksProps from './interfaces/IProfitCenterLinksProps';

import styles from './sass/ProfitCenterLinksCustomers.module.scss';

function ProfitCenterLinksCustomers({
  control,
  profitCenterIds,
  placeholder = '',
  watch,
  setValue,
}: IProfitCenterLinksProps) {
  const { t } = useTranslation();
  const { recordId = '' } = useParams();
  const profitCenterLinks = watch(PROFIT_CENTER_LINKS) || [];
  const { data: userData } = useUserMeQuery();
  const companyCurrency = userData?.data?.company?.currency;
  const profitCenterOptions = profitCenterIds?.[UID_NAME_TUPLES.profitCenter] || [];
  const maxProfitCenters = profitCenterOptions.length;

  const handleAddProfitCenter = () => {
    if (profitCenterLinks.length >= maxProfitCenters) {
      return;
    }
    const newProfitCenter: IProfitCenterLink = {
      ...DATA_NEW_PROFIT_SUPPLIERS,
    };

    setValue(PROFIT_CENTER_LINKS, [...profitCenterLinks, newProfitCenter]);
  };

  const handleRemoveProfitCenter = (index: number) => {
    const updatedLinks = [...profitCenterLinks];
    updatedLinks.splice(index, 1);
    setValue(PROFIT_CENTER_LINKS, updatedLinks);
  };

  const updateProfitCenterField = (index: number, field: keyof IProfitCenterLink, value: string | number | TDate) => {
    const updatedLinks = [...profitCenterLinks];
    updatedLinks[index] = {
      ...updatedLinks[index],
      [field]: value,
    };
    setValue(PROFIT_CENTER_LINKS, updatedLinks);
  };

  if (profitCenterLinks.length === 0 && maxProfitCenters > 0) {
    handleAddProfitCenter();
  }

  return (

    <div className={styles.container}>
      {profitCenterLinks.map((profitCenter: IProfitCenterLink, index: number) => (
        <ProfitCenterItem
          key={`profit-center-${profitCenter.profitCenterId || index}`}
          profitCenter={profitCenter}
          index={index}
          control={control}
          recordId={recordId}
          placeholder={placeholder}
          profitCenterIds={profitCenterIds}
          companyCurrency={companyCurrency}
          onRemove={handleRemoveProfitCenter}
          updateProfitCenterField={updateProfitCenterField}
          showDeleteButton={profitCenterLinks.length > 1 && index !== 0}
        />
      ))}

      {profitCenterLinks.length < maxProfitCenters && (
        <button
          type="button"
          className={styles.addButton}
          onClick={handleAddProfitCenter}
          aria-label={t('common.add')}
        >
          <PlusIcon />
          {t('common.addProfitCentre')}
        </button>
      )}
    </div>

  );
}

export default ProfitCenterLinksCustomers;
